import { patientSexEnum } from "beitary-shared";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";
import { BSelect } from "components/BSelect";

export interface PatientSexSelectProps {
  required?: boolean;
  onChange?: (value: string | undefined) => void;
  error?: ReactNode;
  value?: string; // could be undefined if form has no initial values
}

export const PatientSexSelect = (props: PatientSexSelectProps) => {
  const { t } = useTranslation();

  const data = patientSexEnum.options.map((o) => ({
    value: o,
    label: t(o),
  }));

  return (
    <BSelect
      {...props}
      data={data}
      nothingFound={t("NOTHING_FOUND")}
      label={t("SEXE")}
    />
  );
};
